import React, { useId } from 'react';
import './CompactLoaderMark.scss';
import { useDelayedReveal } from './loadingPolicy';

// The surrounding BrandLoader owns the loading announcement. This mark stays
// decorative and uses a local gradient ID so several pending controls can coexist.
export function CompactLoaderMark({ delay } = {}) {
  const visible = useDelayedReveal(delay);
  const gradientId = `wiw-loader-ring-${useId().replace(/:/g, '')}`;

  return (
    <span className="brand-loader__compact-mark" aria-hidden="true" data-visible={visible}>
      {visible && <svg viewBox="0 0 32 32" width="32" height="32" focusable="false">
        <defs>
          <linearGradient id={gradientId} x1="4" y1="16" x2="28" y2="16" gradientUnits="userSpaceOnUse">
            <stop className="brand-loader__ring-stop--red" offset="0" />
            <stop className="brand-loader__ring-stop--coral" offset="0.167" />
            <stop className="brand-loader__ring-stop--cream" offset="0.333" />
            <stop className="brand-loader__ring-stop--neutral" offset="0.5" />
            <stop className="brand-loader__ring-stop--mint" offset="0.667" />
            <stop className="brand-loader__ring-stop--light-green" offset="0.833" />
            <stop className="brand-loader__ring-stop--green" offset="1" />
          </linearGradient>
        </defs>
        <circle className="brand-loader__ring-outline" cx="16" cy="16" r="12" fill="none" strokeWidth="7" />
        <circle cx="16" cy="16" r="12" fill="none" stroke={`url(#${gradientId})`} strokeWidth="4.4" />
      </svg>}
    </span>
  );
}

export default CompactLoaderMark;
